<template>
  <div
    class="confirmation"
    :class="{
      active: opened == true,
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div
      v-for="item in items"
      :key="item.endpoint.custDestId"
      class="confirmation__box"
    >
      <div class="confirmation__box__close pointer" @click="close()">
        <img src="@/assets/icons/actions/ico-ico-delete-2.svg" />
      </div>
      <div class="confirmation__box__text text-center">
        <p class="text-large">
          PING {{ $t("na") }} <strong>{{ item.endpoint.custDestName }}</strong>
        </p>
        <div class="atom-icon w-100">
          <img
            v-if="item.response == 'error'"
            src="@/assets/icons/actions/ico-ico-delete-red.svg"
          />
          <img v-else src="@/assets/icons/actions/ico-ico-check-green.svg" />
        </div>
        <div>
          <p class="text-center gray-text-light mb-0 text-uppercase text-small">
            {{ $t("stavovyKod") }} {{ item.response }}
          </p>
          <p v-if="item.message" class="gray-text-light">
            {{ item.message }}
          </p>
        </div>
      </div>
      <div
        v-if="item.response == 'error'"
        class="confirmation__box__buttons d-flex align-items-center justify-content-center"
      >
        <!--
        <button class="btn mr-2" @click="close(item)">
          {{ $t("zpet") }}
        </button>
        -->
        <div>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center ml-2"
            @click="repeat(item.endpoint)"
          >
            {{ $t("opakovatPing") }}
          </button>
        </div>
      </div>
      <div
        v-else
        class="confirmation__box__buttons d-flex align-items-center justify-content-end"
      >
        <div>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="close(item)"
          >
            {{ $t("OK") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    opened: Boolean,
    items: Array,
    centered: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    repeat(item) {
      this.$emit("repeat", item);
    },
    close(item) {
      this.$emit("close", item);
    }
  }
};
</script>

<style lang="scss" scoped></style>
